import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["environmentsSelect", "envControls", "saveButton"];

  connect() {
    this.showEnvironments();
    this.element.addEventListener("turbo:submit-end", this.onFormSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-end", this.onFormSubmitEnd);
  }

  environmentsSelectChanged = () => {
    this.showEnvironments();
  };

  onSubmit = () => {
    this.cleanForm();
  };

  // The controller redirects (without Turbo) on success, but renders the form
  // via a Turbo frame if there are validation errors. This returns the user to
  // the top of the page where they are likely to see them.
  onFormSubmitEnd = (event) => {
    if (event.detail.fetchResponse?.response?.status === 422) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  onKeyDown = (event) => {
    // When Enter is pressed, prevent default and submit form via save button.
    // This is necessary to override the default behavior which is to submit
    // with the first submit button found in the DOM, which may be the test
    // button in our case.
    if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
      event.preventDefault();
      this.saveButtonTarget.click();
    }
  };

  showEnvironments() {
    if (!this.hasEnvironmentsSelectTarget) return;

    const value = this.environmentsSelectTarget.value;
    this.envControlsTargets.forEach((control) => {
      control.style.display = "none";
    });

    const targetControl = document.getElementById(`${value}_environments`);
    if (targetControl) {
      targetControl.style.display = "block";
    }
  }

  // This removes the excluded_environment and/or included_environment checkboxes,
  // depending on the option selected in the select box, so that the controller will
  // receive an empty array for the lists that should be wiped. E.g, if a user wants
  // to specify the allow-list (included_environments), then excluded_environments
  // will be set to [], clearing out any previously-set values for that field.
  cleanForm() {
    if (!this.hasEnvironmentsSelectTarget) return;

    const value = this.environmentsSelectTarget.value;

    switch (value) {
      case "all":
        this.removeFormChecks("#excluded_environments .form-check");
        this.removeFormChecks("#included_environments .form-check");
        break;
      case "excluded":
        this.removeFormChecks("#included_environments .form-check");
        break;
      case "included":
        this.removeFormChecks("#excluded_environments .form-check");
        break;
    }
  }

  removeFormChecks(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element) => element.remove());
  }
}
